import { Injectable, signal } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    depositRedirectInProgress = signal<boolean>(false);
    isLoading = new BehaviorSubject(true);
}
